import Conf from "@/assets/conf/setting.json";
import { kickUrlParam } from "@/common/utils.js";

// 获取 officeWeb365 预览src地址
export function getPreviewUrl(extType, url) {
  if (!extType || !url) return "";

  let previewUrl = "";
  if (extType === "image") previewUrl = kickUrlParam(url, "type");
  if (extType === "video" || extType === "audio") previewUrl = url;
  if ("doc,excel,txt,rar".indexOf(extType) > -1) {
    previewUrl = Conf.officePrefixUrl + url;
  }

  if (previewUrl.indexOf("https") > -1) previewUrl += "&ssl=1";
  return previewUrl;
}

export const extentionMap = [
  {
    type: "image",
    iconSrc: "images/file-icon/file-image.png",
    extentions: "jpg,jpeg,gif,png,bmp,tiff,psd,svg"
  },
  {
    type: "doc",
    iconSrc: "images/file-icon/file-doc.png",
    extentions: "doc,docx,docm,dotm,dotx"
  },
  {
    type: "excel",
    iconSrc: "images/file-icon/file-excel.png",
    extentions: "xlsx,xlsb,xls,xlsm"
  },
  {
    type: "ppt",
    iconSrc: "images/file-icon/file-ppt.png",
    extentions: "pptx,ppsx,ppt,pps,pptm,potm,ppam,potx,ppsm"
  },
  {
    type: "pdf",
    iconSrc: "images/file-icon/file-pdf.png",
    extentions: "pdf"
  },
  {
    type: "txt",
    iconSrc: "images/file-icon/file-text.png",
    extentions: "txt"
  },
  {
    type: "video",
    iconSrc: "images/file-icon/file-video.png",
    extentions: "mp4,wmv,asf,asx,rm,rmvb,3gp,mov,m4v,avi,dat,mkv,vob"
  },
  {
    type: "flv",
    iconSrc: "images/file-icon/file-flv.png",
    extentions: "flv"
  },
  {
    type: "audio",
    iconSrc: "images/file-icon/file-audio.png",
    extentions: "mp3,wav,aiff,pcm,flac,alac,wma,aac"
  },
  {
    type: "rar",
    iconSrc: "images/file-icon/file-zip.png",
    extentions: "7z,rar,zip,gz,bz,ace,uha,uda,zpaq"
  },
  {
    type: "other",
    iconSrc: "images/file-icon/file-other.png",
    extentions: ""
  }
];

export function extentionMapFilter(ext) {
  for (var i = 0; i < extentionMap.length; i++) {
    if (!!ext && extentionMap[i]["extentions"].indexOf(ext) > -1) {
      return extentionMap[i];
    }
  }
  return extentionMap[extentionMap.length - 1];
}

// 文件下载

// 直接下载
export function downloadFileDirect(fileUrl) {
  // console.log("# download file url: ", fileUrl);
  let a = document.createElement("a");
  a.setAttribute("target", "_blank");
  a.setAttribute("href", fileUrl);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// 邮箱下载
